<template>
  <section class="container">
    <div class="management_top_box">
      <h4>{{ $t("management.classifyRegionsManagement") }}</h4>
    </div>
    <div class="mgt_top_box">
      <dl>
        <dt style="line-height: 60px">{{ $t("management.region") }}</dt>
        <dd>
          <select v-model="region" class="int_type01 mgt_seltype">
            <option value="">--{{ $t("common.region") }}--</option>
            <option v-for="(region, index) in regions" :key="index" :value="region">
              {{ region.codeName }}
            </option>
          </select>
          <button @click="showNewBox()" class="btn btn-primary btn-md m-2">
            {{ $t("common.add") }}
          </button>
        </dd>
        <span class="default_notice">* {{ $t("management.classifyDefault") }}</span>
      </dl>
    </div>
    <div class="p-2" style="text-align: right">
      <button @click="saveRegionExhaustCerti" class="btn btn-primary btn-md m-1">
        {{ $t("common.save") }}
      </button>
    </div>
    <div>
      <table class="mgt_tbl">
        <tbody v-for="(reg, index) in regionList" :key="index">
          <tr>
            <th rowspan="2">{{ reg.regionName }}</th>
            <td>
              <select
                v-model="reg.exhaustCertiId"
                class="int_type01 mgt_seltype"
                :id="reg.regionCode"
                :disabled="checkDisabled(reg.regionCode)"
              >
                <option value="">-{{ $t("management.exhaustCertification") }}-</option>
                <option value="All">{{ $t("common.all") }}</option>
                <option
                  v-for="(ex, index) in exhaustList"
                  :key="index"
                  :value="ex.exhaustCertiId"
                >
                  {{ ex.exhaustCertiName }}
                </option>
              </select>
              <button @click="addNewExhaustCerti(reg)" class="btn btn-primary btn-sm m-2">
                {{ $t("common.add") }}
              </button>
              <button
                @click="deleteRegion(reg, index)"
                class="btn btn-secondary btn-sm m-2"
              >
                {{ $t("common.delete") }}
              </button>
            </td>
          </tr>
          <tr>
            <td>
              <div
                v-for="(ex, index) in regionExhuast"
                :key="index"
                style="display: inline-block"
              >
                <span v-if="reg.regionCode == ex.regionCode" :id="index" class="m-1">
                  {{ ex.exhaustCertiName }}
                  <button
                    type="button"
                    @click="deleteExhaust(ex, index)"
                    class="btn btn-secondary btn-sm m-1 delete_button"
                  >
                    x
                  </button>
                </span>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      <!-- 페이징 추가 -->
      <div v-if="regionList.length != 0 && pagingVO" class="paging_nav">
        <div class="paging_nav">
          <a
            href="#"
            v-if="pagingVO.startPage <= pagingVO.blockSize"
            class="page_select prev_page disabled"
            >이전페이지 이동</a
          >
          <a
            v-else
            class="page_select prev_page"
            @click="searchPage(pagingVO.startPage - pagingVO.blockSize)"
            v-bind:data-page="pagingVO.startPage - pagingVO.blockSize"
            >이전페이지 이동</a
          >
          <span
            v-for="(pages, index) in pagingVO.endPage - pagingVO.startPage + 1"
            :key="index"
          >
            <strong v-if="pagingVO.startPage + index == pagingVO.currentPage">{{
              pagingVO.startPage + index
            }}</strong>
            <a href="#" v-else @click="searchPage(pagingVO.startPage + index)">{{
              pagingVO.startPage + index
            }}</a>
          </span>
          <a
            v-if="pagingVO.endPage >= pagingVO.totalPage"
            href="#"
            class="page_select next_page disabled"
            >다음페이지 이동</a
          >
          <a
            v-else
            href="#"
            @click="searchPage(pagingVO.endPage + 1)"
            v-bind:data-page="pagingVO.endPage + 1"
            class="page_select next_page"
            >다음페이지 이동</a
          >
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import $ from "jquery";
import {
  getRegionAndExhaustCerti,
  saveRegionExhaustCerti,
} from "@/api/regionexhaustcerti";
export default {
  data() {
    return {
      regions: [],
      region: "",
      regionList: [],
      exhaustList: [],
      regionExhuast: [],
      pagingVO: "",
      form: {
        page: 1,
      },
      showYN: false,
      exhaustCerti: "",
      exhaustCertiName: "",
      newRegion: {
        id: "",
        regionCode: "",
        exhaustCertiId: "",
        regionName: "",
        crudType: "I",
        newBox: true,
      },
      confirmYN: false,
      addList: 0,
    };
  },
  mounted() {
    this.fetchData(this.form.page);
  },
  methods: {
    reset() {
      this.regions = [];
      this.region = "";
      this.regionList = [];
      this.exhaustList = [];
      this.regionExhuast = [];
      this.pagingVO = "";
      this.form.page = 1;
      this.showYN = false;
      this.exhaustCerti = "";
      this.exhaustCertiName = "";
      this.newRegion = {
        id: "",
        regionCode: "",
        exhaustCertiId: "",
        regionName: "",
        crudType: "I",
        newBox: true,
      };
      this.confirmYN = false;
      this.addList = 0;
    },
    async fetchData(page) {
      try {
        this.form.page = page;
        const { data } = await getRegionAndExhaustCerti(this.form);
        this.regions = data.regions;
        this.exhaustList = data.certiList;
        // 지역만 (페이징 적용된 데이터)
        this.regionList = data.pagingVO.dataList;
        // 지역및 배기인증
        this.regionExhuast = data.regionExhuast;
        // 페이징 정보
        this.pagingVO = data.pagingVO;
      } catch (err) {
        console.log(err);
      }
    },
    searchPage(page) {
      // 페이지 클릭 시
      this.form.page = page;
      this.fetchData(this.form.page);
    },
    // 배기 하나씩 삭제
    deleteExhaust(ex, index) {
      this.confirmYN = confirm(this.$t("alert.delete"));
      if (this.confirmYN) {
        $("#" + index).remove();
        this.regionExhuast[index].crudType = "U";
        // if (ex.exhaustCertiId === "All") {
        //   this.checkDisabled(ex.regionCode);
        // }
      } else {
        return;
      }
    },
    // 지역 (배기포함) 전체 삭제
    deleteRegion(reg, index) {
      this.confirmYN = confirm(this.$t("alert.delete"));
      if (reg.newBox) {
        this.addList = 0;
      }
      if (this.confirmYN) {
        this.regionList.splice(index, 1);
        for (let i in this.regionExhuast) {
          if (this.regionExhuast[i].regionCode == reg.regionCode) {
            this.regionExhuast[i].crudType = "D";
          }
        }
        alert(this.$t("alert.deletedSuccessfullyButYouNeedToClickTheSaveButton"));
      } else {
        return;
      }
    },
    // 새로운 지역추가
    showNewBox() {
      if (this.addList == 1) {
        alert(this.$t("alert.youCanCddOnlyOneAtOnce"));
        return;
      }
      if (this.region == "") {
        alert(this.$t("alert.pleaseSelectTheRegion"));
        return;
      }
      for (let i in this.regionList) {
        if (this.regionList[i].regionCode == this.region.codeId) {
          alert(this.$t("alert.alreadyExist"));
          this.region = "";
          return;
        }
      }
      this.addList = this.addList + 1;
      this.newRegion.regionCode = this.region.codeId;
      this.newRegion.regionName = this.region.codeName;
      this.regionList.unshift(this.newRegion);
    },
    // 새로운 배기인증 추가
    addNewExhaustCerti(reg) {
      if (reg.exhaustCertiId == "") {
        alert(this.$t("alert.pleaseSelectExhaustCertification"));
        return;
      }
      // exhaustCertiName 할당
      for (let i in this.exhaustList) {
        if (this.exhaustList[i].exhaustCertiId == reg.exhaustCertiId) {
          reg.exhaustCertiName = this.exhaustList[i].exhaustCertiName;
        }
      }
      if (reg.exhaustCertiId === "All") {
        reg.exhaustCertiName = "All";
        for (let i in this.regionExhuast) {
          if (this.regionExhuast[i].regionCode == reg.regionCode) {
            $("#" + i).remove();
            this.regionExhuast[i].crudType = "U";
          }
        }
      }
      if (reg === "new") {
        this.regionExhuast.push({
          id: "",
          regionCode: this.newRegion.regionCode,
          exhaustCertiId: reg.exhaustCertiId,
          exhaustCertiName: reg.exhaustCertiName,
          crudType: "I",
        });
      } else {
        this.regionExhuast.push({
          id: "",
          regionCode: reg.regionCode,
          exhaustCertiId: reg.exhaustCertiId,
          exhaustCertiName: reg.exhaustCertiName,
          crudType: "I",
        });
      }
    },
    // 변경사항 추가/삭제
    async saveRegionExhaustCerti() {
      this.confirmYN = confirm(this.$t("alert.save"));
      if (this.confirmYN) {
        try {
          const { data } = await saveRegionExhaustCerti(this.regionExhuast);
          if (data.status) {
            this.addList = 0;
            alert(this.$t("alert.changedSuccessfully"));
            // reset
            this.reset();
            this.fetchData(1);  // 첫 페이지로 이동
          } else {
            alert(this.$t("alert.ErrorPlzcontactManager"));
          }
        } catch (err) {
          console.log(err);
        }
      } else {
        return;
      }
    },
    // all 일때 disabled
    checkDisabled(regionCode) {
      let chk = false;
      for (let i in this.regionExhuast) {
        console.log(this.regionExhuast[i]);
        if (regionCode == this.regionExhuast[i].regionCode) {
          if (
            this.regionExhuast[i].exhaustCertiId == "All" &&
            this.regionExhuast[i].crudType != "U"
          ) {
            chk = true;
            break;
          }
        }
      }
      return chk;
    },
  },
};
</script>

<style scoped>
.mgt_tbl {
  table-layout: fixed;
  width: 100%;
}

.mgt_tbl th {
  width: 200px;
  word-wrap: break-word;
}

.mgt_tbl td {
  word-wrap: break-word;
}

.default_notice {
  display: block;
  margin-top: 4px;
  font-size: 12px;
  color: #888;
}
</style>
